<p class="text-xs text-muted-foreground">
  Die Analysedatei wird beim <span class="font-normal text-foreground">Geocut</span> erzeugt.
  Wählen Sie den Analysetyp, der anschließend für Erkennung und Planung verwendet werden soll:
</p>

<div class="space-y-1.5 mt-2">
  <button
    type="button"
    class="w-full flex items-center gap-3 rounded-md border p-3 text-left transition-colors"
    [class]="selected() === '2d' ? 'border-primary bg-primary/5' : 'border-border hover:bg-muted/40'"
    [disabled]="disabled()"
    (click)="select('2d')"
  >
    <div class="flex h-8 w-8 shrink-0 items-center justify-center rounded-md border bg-success-soft text-success">
      <ng-icon name="lucideImage" class="w-4 h-4" />
    </div>
    <div class="flex-1 min-w-0">
      <div class="flex items-center gap-2 flex-wrap">
        <span class="text-sm font-normal">2D-Analyse (Luftbild)</span>
        @if (showAppliedBadge() && selected() === '2d') {
          <span class="inline-flex items-center gap-1 rounded-full border border-primary/30 bg-primary/10 px-2 py-0.5 text-xs font-normal text-primary">
            <ng-icon name="lucideCheck" class="w-2.5 h-2.5" />
            Ausgewählt
          </span>
        }
      </div>
      <p class="text-xs text-muted-foreground mt-0.5">Geocut erzeugt ein 2D-Luftbild als Grundlage</p>
    </div>
  </button>

  <button
    type="button"
    class="w-full flex items-center gap-3 rounded-md border p-3 text-left transition-colors"
    [class]="selected() === '3d' ? 'border-primary bg-primary/5' : 'border-border hover:bg-muted/40'"
    [disabled]="disabled()"
    (click)="select('3d')"
  >
    <div class="flex h-8 w-8 shrink-0 items-center justify-center rounded-md border bg-secondary text-muted-foreground">
      <ng-icon name="lucideBox" class="w-4 h-4" />
    </div>
    <div class="flex-1 min-w-0">
      <div class="flex items-center gap-2 flex-wrap">
        <span class="text-sm font-normal">3D-Analyse (3D-Modell)</span>
        @if (showAppliedBadge() && selected() === '3d') {
          <span class="inline-flex items-center gap-1 rounded-full border border-primary/30 bg-primary/10 px-2 py-0.5 text-xs font-normal text-primary">
            <ng-icon name="lucideCheck" class="w-2.5 h-2.5" />
            Ausgewählt
          </span>
        }
      </div>
      <p class="text-xs text-muted-foreground mt-0.5">Geocut erzeugt ein 3D-Modell als Grundlage</p>
    </div>
  </button>
</div>
